export default {
	title: '告警处理',
	actions: {
		add: '新增',
		edit: '修改',
		delete: '删除',
		batchDelete: '批量删除',
		save: '保存',
		cancel: '取消',
		confirm: '确定'
	},
	messages: {
		deleteSuccess: '删除成功',
		actionSuccess: '操作成功',
		requiredError: '必填项不能为空'
	},
	buttons: {
		add: '新增',
		batchDelete: '批量删除',
		edit: '修改',
		delete: '删除',
		export: '导出',
		exportAll: '导出全部',
		exportSelected: '导出勾选项'
	},
	table: {
		warnTitle: '告警标题',
		projName: '项目名称',
		deviceName: '设备名称',
		pointName: '测点名称',
		orgName: '所属机构',
		warnLevel: '告警等级',
		warnTime: '告警时间',
		featureValue: '特征值',
		content: '内容',
		handleAction: '处理操作',
		reviewResult: '复核结果',
		correct: '正确',
		incorrect: '不正确',
		handler: '处理人',
		handleTime: '处理时间',
		action: '操作'
	},
	form: {
		placeholder: {
			projName: '项目名称',
			deviceName: '设备名称',
			pointName: '测点名称',
			orgId: '机构名称',
			startTime: '开始时间',
			endTime: '结束时间'
		},
		label: {
			gearName: '齿轮名称',
			gearBrand: '齿轮品牌',
			bpfo: '外圈故障特征频率',
			bpfi: '内圈故障特征频率',
			bsf: '滚动体故障特征频率',
			ftf: '保持架故障特征频率'
		}
	},
	config: {
		gridLayout: '格栅布局'
	},
	dialog: {
		add: '新增',
		update: '修改'
	}
}
